import { supabase } from '@/supabase-client'

/**
 * Reconcile a customer's invoices against Xero aged receivables.
 *
 * Calls the xero-invoices Edge Function with the reconcile-customer action.
 * Xero is treated as the source of truth — any discrepancies found are resolved
 * by updating Odin's records.
 *
 * @param {string} customerId - The Odin customer UUID to reconcile
 * @param {Object} [options]
 * @param {Function} [options.onProgress] - Optional progress callback receiving a status string
 * @returns {Promise<{ success: boolean, reconciled: boolean, invoices_updated: number, payments_created: number, discrepancies: Array }>}
 */
export async function reconcileCustomer(customerId, { onProgress } = {}) {
  onProgress?.('Reconciling with Xero...')

  const { data, error } = await supabase.functions.invoke('xero-invoices', {
    body: {
      action: 'reconcile-customer',
      customer_id: customerId
    }
  })

  if (error) throw error
  if (!data?.success) throw new Error(data?.error || 'Reconciliation failed')

  return data
}
